import Vue from 'vue'
import router from '@/router'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

NProgress.configure({ ease: 'ease', speed: 500 })

const auths = []

class permission {
    Check(key) {
        var checkauth = authCode => {
            if (authCode) {
                for (let i in this.auths) {
                    if (this.auths[i] === authCode) return true
                }
                return false
            }
            return true
        }
        //判断多个权限
        if (typeof key == 'string') {
            return checkauth(key)
        } else if (typeof key == 'object') {
            for (let index = 0; index < key.length; index++) {
                if (checkauth(key[index])) {
                    return true
                }
            }
            return false
        }
    }
    setAuths(list) {
        if (list && list.length) {
            this.auths = list
            sessionStorage.setItem('auths', JSON.stringify(this.auths || []))
        } else {
            this.auths = JSON.parse(sessionStorage.getItem('auths')) || []
        }
    }
    removeAuths() {
        this.auths = []
        sessionStorage.removeItem('auths')
    }
}

const Permission = new permission()

Permission.setAuths()

Vue.directive('authority', {
    inserted(el, binding) {
        if (!Permission.Check(binding.value)) el.parentNode && el.parentNode.removeChild(el)
    }
})

//全局前置钩子
router.beforeEach((to, from, next) => {
    NProgress.start()
    // 登陆页面
    if (to.path == '/login' || to.name == 'login' || to.path == '/andonOrderJump' || to.name == 'andonOrderJump' ||to.path == '/acoustoSpectaculars2' || to.name == 'acoustoSpectaculars2' || to.path == '/andonOrderDetailJump' || to.name == 'andonOrderDetailJump') {
        next()
    } else {
        let token = sessionStorage.getItem('authToken')
        //无token则跳转登陆
        if (token) {
            //权限校验
            if (to.meta && to.meta.authCode) {
                if (Permission.Check(to.meta.authCode)) {
                    next()
                } else {
                    next({ path: '/401' })
                }
            } else {
                next()
            }
        } else {
            next({ path: '/login' })
            Message.warning('请登录！')
        }
    }
    NProgress.done()
})

// 全局后置钩子
router.afterEach(transition => {
    NProgress.done()
})

export default Permission
